import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '@core/services/core/auth/auth.service';
import { ContextService } from '@core/services/core/context.service';
import { MenuService } from '@core/services/core/menu.service';
import { MMobileHelperService } from '@core/services/core/mmobile-helper.service';
import { NavController, Platform } from '@ionic/angular';
import { TeCuidamosUserData } from '../../../core/models/user';
import { TecuidamosService } from '../../../core/services/core/tecuidamos.service';
import { UrlHelper } from '../../../core/services/helpers/url-helper.service';
import { AllFeatureFlags } from '@models/mmobile';
@Component({
  selector: 'mapfre-footer',
  templateUrl: './mapfre-footer.component.html',
  styleUrls: ['./mapfre-footer.component.scss']
})
export class MapfreFooterComponent implements OnInit {
  @Input() mobileWeb = true;
  @Input() hasBottomSlider = false;
  teCuidamosState: TeCuidamosUserData;
  isRgpduePolicyEnabled = false;

  constructor(
    public platform: Platform,
    public ctx: ContextService,
    public auth: AuthService,
    public menu: MenuService,
    private nav: NavController,
    private tecuidamos: TecuidamosService,
    private url: UrlHelper,
    public mmobileHelper: MMobileHelperService
  ) {}

  ngOnInit() {
    this.tecuidamos
      .getState$()
      .subscribe(state => (this.teCuidamosState = state));

    this.isRgpduePolicyEnabled = this.mmobileHelper.checkIsFeatureEnabled(AllFeatureFlags.RGPDUE_POLICY_ACCEPTANCE);
  }

  navTo(path, params?) {
    this.nav.navigateForward(path, { state: params });
  }

  openCookiesPolicy() {
    this.url.open(
      this.mmobileHelper.getCustomConfigData('policyAppWebV2', 'cookieUrl')
    );
  }

  openLegalWarning() {
    this.url.open(
      this.mmobileHelper.getCustomConfigData('policyAppWebV2', 'legalWarningUrl')
    );
  }

  openTeCuidamos() {
    this.url.open('https://www.mapfretecuidamos.com/tecuidamos/index.do');
  }

  openTeCuidamosBusiness() {
    this.url.open('https://www.mapfretecuidamos.com/empresas/');
  }

  openPrivacyPolicyBusiness() {
    this.url.open(
      this.mmobileHelper.getCustomConfigData('URLS', 'PRIVACY_POLICY_BUSINESS')
    );
  }

  openCookiesPolicyBusiness() {
    this.url.open(
      this.mmobileHelper.getCustomConfigData('URLS', 'COOKIES_POLICY_BUSINESS')
    );
  }

  navToContactForm() {
    this.auth.getState()?.isLogged
      ? this.nav.navigateForward(['businesses', 'contact', 'private'])
      : this.nav.navigateForward(['login', 'empresas', 'contacto']);
  }
}
